import { Tooltip, Slider } from "@mui/material";
import React from "react";

function ValueLabelComponent(props) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

const TooltipSlider = (props) => {
  return (
    <Slider
      {...props}
      valueLabelDisplay="auto"
      sx={{
        "& .MuiSlider-thumb": {
          color: "#fff",
          width: "15px",
          height: "15px",
        },
        "& .MuiSlider-track": {
          color: "#8b58f1",
        },
        "& .MuiSlider-rail": {
          color: "#8b58f180",
        },
      }}
      min={props?.min ? Number(props?.min) : undefined}
      max={props?.max ? Number(props?.max) : undefined}
      step={props?.step ? Number(props?.step) : undefined}
      slots={{
        valueLabel: ValueLabelComponent,
      }}
      aria-label="thumb label"
    />
  );
};

export default TooltipSlider;
